/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import bigDataLog from '@/utils/bigDataLog';
import bigDataConfig from '@/bigData/index';
import Home from '@/Home.vue';
import Root from '@/Root.vue'

import {
    splitModName,
    getModResources,
    generateRoutes

} from '../utils/module';
import config from '@/config/user.env';
import cookies from 'js-cookie';
import { logout } from '../utils/index';
Vue.use(Router);

export const routeConfig = [
    {
        path: window.__MICRO_APP_BASE_ROUTE__ || '/',
        component: Home,
        redirect: '/index',
        children: [
            {
                path: '/redirect/:path*',
                component: () => import('@/modules/redirect/index')
            },
            {
                path: '/index',
                name: 'index',
                meta: {
                    resourceName: '首页',
                },
                component: () => import('@/views/index/Main.vue')
            },
            {
                path: '/org/incomeOverview',
                name: 'orgincomeOverview',
                meta: {
                    title: '收入概览',
                    resourceName: '组织-逾期概览',
                },
                component: () => import('@/views/subPage/org/incomeOverview/index.vue')

            },
            {
                path: '/org/businessOverview',
                name: 'orgbusinessOverview',
                meta: {
                    title: '商机概览',
                    resourceName: '组织-商机概览',
                },
                component: () => import('@/views/subPage/org/businessOverview/index.vue')
            },
            {
                path: '/org/overdueOverview',
                name: 'orgoverdueOverview',
                meta: {
                    title: '逾期应收概览',
                    resourceName: '组织-逾期应收概览',
                },
                component: () => import('@/views/subPage/org/overdueOverview/index.vue')
            },
            {
                path: '/org/signingOverview',
                name: 'orgsigningOverview',
                meta: {
                    title: '签单概览',
                    resourceName: '组织-签单概览',
                },
                component: () => import('@/views/subPage/org/signingOverview/index.vue')
            },
            {
                path: '/org/complaintView',
                name: 'orgcomplaintView',
                meta: {
                    title: '客户KPI及客诉',
                    resourceName: '组织-客户KPI及客诉',
                },
                component: () => import('@/views/subPage/org/complaintView/Index.vue')
            },
            {
                path: '/org/satisfactionOrderView',
                name: 'orgsatisfactionOrderView',
                meta: {
                    title: '客户满意度及工单',
                    resourceName: '组织-客户满意度及工单',
                },
                component: () => import('@/views/subPage/org/satisfactionOrderView/Index.vue')
            },
            {
                path: '/personal/incomeOverview',
                name: 'personalincomeOverview',
                meta: {
                    title: '收入概览',
                    resourceName: '个人-收入概览',
                },
                component: () => import('@/views/subPage/personal/incomeOverview/index.vue')

            },
            {
                path: '/personal/businessOverview',
                name: 'personalbusinessOverview',
                meta: {
                    title: '商机概览',
                    resourceName: '个人-商机概览',
                },
                component: () => import('@/views/subPage/personal/businessOverview/index.vue')
            },
            {
                path: '/personal/overdueOverview',
                name: 'personaloverdueOverview',
                meta: {
                    title: '逾期应收概览',
                    resourceName: '个人-逾期应收概览',
                },
                component: () => import('@/views/subPage/personal/overdueOverview/index.vue')
            },
            {
                path: '/personal/signingOverview',
                name: 'personalsigningOverview',
                meta: {
                    title: '签单概览',
                    resourceName: '个人-签单概览',
                },
                component: () => import('@/views/subPage/personal/signingOverview/index.vue')
            },
            {
                path: '/personal/complaintView',
                name: 'personalcomplaintView',
                meta: {
                    title: '客户KPI及客诉',
                    resourceName: '个人-客户KPI及客诉',
                },
                component: () => import('@/views/subPage/personal/complaintView/Index.vue')
            },
            {
                path: '/personal/satisfactionOrderView',
                name: 'personalsatisfactionOrderView',
                meta: {
                    title: '客户满意度及工单',
                    resourceName: '组织-客户满意度及工单',
                },
                component: () => import('@/views/subPage/personal/satisfactionOrderView/Index.vue')
            },
            {
                path: '/search',
                name: 'search',
                meta: {
                    title: '搜索',
                },
                component: () => import('@/views/index/searchBox/Index.vue')
            },
            // {
            //     path: '/customer-manage',
            //     name: 'customerManage',
            //     meta: {
            //         title: '客户管理',
            //     },
            //     component: () => import('@/modules/mdm/views/customerModules/customerManage/Index.vue')
            // },
            {
                path: '/user-center',
                name: 'userCenter',
                component: () => import('@/components/lots/userCenter/UserCenter.vue')
            },
            {
                path: '/mipIframe',
                name: 'mipIframe',
                meta: { title: '合同流程审批' },
                component: () => import('@/modules/mdm/views/contractModules/components/mipIframe.vue')
            },
            {
                path: '/opportunityApplication',
                name: 'opportunityApplication',
                meta: { title: '商机准入申请' },
                component: () => import('@/modules/mdm/views/opportunityModules/opportunityApplication/Index.vue')
            },
            {
                path: '/contractRegistrationToDo',
                name: 'contractRegistrationToDo',
                meta: { title: '合同续签待办' },
                component: () => import('@/modules/mdm/views/contractModules/contractRegistrationToDo/Index.vue')
            },
            {
                path: '/strategicCooperationMaintenance',
                name: 'strategicCooperationMaintenance',
                meta: { title: '战合客户信息快速维护' },
                component: () => import('@/modules/mdm/views/customerModules/strategicCooperationMaintenance/Index.vue')
            },
            {
                path: '/strategicCooperationIntroduceApply',
                name: 'strategicCooperationIntroduceApply',
                meta: { title: '战合客户引入申请' },
                component: () => import('@/modules/mdm/views/customerModules/strategicCooperationIntroduceApply/Index.vue')
            },
            {
                path: '/strategicCooperationIntroduceUpdate',
                name: 'strategicCooperationIntroduceUpdate',
                meta: { title: '战合客户信息修改' },
                component: () => import('@/modules/mdm/views/customerModules/strategicCooperationIntroduceUpdate/Index.vue')
            },
            {
                path: '/customerPersonResponserEdit',
                name: 'customerPersonResponserEdit',
                meta: { title: '责任人变更流程' },
                component: () => import('@/modules/mdm/views/customerModules/customerPersonResponserEdit/Index.vue')
            },
            {
                path: '/strategicCooperationTermination',
                name: 'strategicCooperationTermination',
                meta: { title: '战合客户终止申请' },
                component: () => import('@/modules/mdm/views/customerModules/strategicCooperationTermination/Index.vue')
            },
            {
                path: '/approveFlow',
                name: 'approveFlow',
                meta: { title: '流程信息' },
                component: () => import('@/modules/mdm/views/contractModules/approveFlow/Index')
            },
            {
                path: '/resourceApplication',
                name: 'resourceApplication',
                meta: { title: 'IT资源对接申请' },
                component: () => import('@/modules/mdm/views/opportunityModules/resourceApplication/Index.vue')
            },
            {
                path: '/opportunityBatch',
                name: 'opportunityBatch',
                meta: { title: '商机批量创建' },
                component: () => import('@/modules/mdm/views/opportunityModules/opportunityBatch/Index.vue')
            },
            {
                path: '/registractionFlow',
                name: 'registractionFlow',
                meta: { title: '退出报告提交流程' },
                component: () => import('@/modules/mdm/views/contractModules/contractRegistration/registractionFlow/Index.vue')
            },
            {
                path: '/delApplyFlow',
                name: 'delApplyFlow',
                meta: { title: '删除数据提交流程' },
                component: () => import('@/modules/mdm/views/contractModules/contractRegistration/delApplyFlow/Index.vue')
            },
            {
                path: '/whiteListFlow',
                name: 'whiteListFlow',
                meta: { title: '白名单审批流程' },
                component: () => import('@/modules/mdm/views/customerModules/customerManage/whiteListFlow/Index.vue')
            },
            {
                path: '/responsibleFlow',
                name: 'responsibleFlow',
                meta: { title: '责任制详情' },
                component: () => import('@/modules/mdm/views/customerModules/customerPersonResponsibleData/responsibleFlow/Index.vue')
            },
            {
                path: '/customerApplyFlow',
                name: 'customerApplyFlow',
                meta: { title: '客户新增提交流程' },
                component: () => import('@/modules/mdm/views/customerModules/customerManage/customerApplyFlow/Index.vue')
            },
            {
                path: '/customerChangeFlow',
                name: 'customerChangeFlow',
                meta: { title: '客户变更流程' },
                component: () => import('@/modules/mdm/views/customerModules/customerManage/customerChangeFlow/Index.vue')
            },
            {
                path: '/customerIntroductionChangeFlow',
                name: 'customerIntroductionChangeFlow',
                meta: { title: '客户引入申请单' },
                component: () => import('@/modules/mdm/views/customerModules/customerIntroduction/customerIntroductionChangeFlow/Index.vue')
            },
            {
                path: '/customer-introduction',
                name: 'customerIntroduction',
                meta: { title: '海外业务引入' },
                component: () => import('@/modules/mdm/views/customerModules/customerIntroduction/Index.vue')
            },
            {
                path: '/incomeSharingRules',
                name: 'incomeSharingRules',
                meta: { title: '提成分配规则变更' },
                component: () => import('@/modules/mdm/views/customerModules/customerPersonResponsible/incomeSharingRules/Index.vue')
            },
            {
                path: '/goalManage',
                name: 'goalManage',
                meta: { title: '目标变更流程' },
                component: () => import('@/modules/mdm/views/opportunityModules/goalManage/Index.vue')
            },
            {
                path: '/customerVisitFlow',
                name: 'customerVisitFlow',
                meta: { title: '拜访人审批' },
                component: () => import('@/modules/mdm/views/customerModules/customerVisitManage/customerVisitFlow/Index.vue')
            },
            {
                path: '/report/preview/:id',
                name: 'reportPreview',
                meta: { title: '报表平台' },
                component: () => import('@/modules/mdm/views/report/reportPreview/Index.vue')
            },
            {
                path: '/attendanceRulesSettings',
                name: 'attendanceRulesSettings',
                meta: {
                    resourceName: '考勤规则配置',
                },
                component: () => import('@/views/attendanceRuleSettings/index.vue')
            },
            // {
            //     path:'/renewalPending',
            //     name:'renewalPending',
            //     meta:{
            //         resourceName: '续签待办',
            //     },
            //     component: () => import('@/modules/mdm/views/pendingManagerModules/renewalPending/Index.vue')
            // },
            // {
            //     path:'/renewalEdit',
            //     name:'renewalEdit',
            //     meta:{
            //         resourceName: '续签特权操作',
            //     },
            //     component: () => import('@/modules/mdm/views/pendingManagerModules/renewalEdit/Index.vue')
            // },
            {
                path:'/lead-import-manage',
                name:'leadImportManage',
                meta:{ title:'线索导入' },
                component:() => import('@/modules/mdm/views/leadManagerModules/leadImportManage/Index.vue')
            }
        ]
    },
    {
        path: '/mipIframe',
        name: 'mipIframe',
        meta: { title: '合同流程审批' },
        component: () => import('@/modules/mdm/views/contractModules/components/mipIframe.vue')
    },
    {
        path: '/opportunityApplication',
        name: 'opportunityApplication',
        meta: { title: '商机准入申请' },
        component: () => import('@/modules/mdm/views/opportunityModules/opportunityApplication/Index.vue')
    },
    {
        path: '/contractRegistrationToDo',
        name: 'contractRegistrationToDo',
        meta: { title: '合同续签待办' },
        component: () => import('@/modules/mdm/views/contractModules/contractRegistrationToDo/Index.vue')
    },
    {
        path: '/strategicCooperationMaintenance',
        name: 'strategicCooperationMaintenance',
        meta: { title: '战合客户信息快速维护' },
        component: () => import('@/modules/mdm/views/customerModules/strategicCooperationMaintenance/Index.vue')
    },
    {
        path: '/strategicCooperationIntroduceApply',
        name: 'strategicCooperationIntroduceApply',
        meta: { title: '战合客户引入申请' },
        component: () => import('@/modules/mdm/views/customerModules/strategicCooperationIntroduceApply/Index.vue')
    },
    {
        path: '/customerPersonResponserEdit',
        name: 'customerPersonResponserEdit',
        meta: { title: '责任人变更流程' },
        component: () => import('@/modules/mdm/views/customerModules/customerPersonResponserEdit/Index.vue')
    },
];

if (window.__MICRO_APP_ENVIRONMENT__) {
    routeConfig[0].component = Root;
    routeConfig[0].children.forEach(item => {
        item.path = window.__MICRO_APP_BASE_ROUTE__ + item.path;
    });
}
const router = new Router({
    // base: process.env.BASE_URL,
    routes: routeConfig
});

// 记录注册过的模块
const registeredRouterRecord = [];

/**
 * @description 检查模块是否注册
 * @param {String} modName 模块名
 */
const isModRegistered = modName => {
    return registeredRouterRecord.includes(modName);
};

/**
 * @description 注册模块
 * @param {String} modName 模块名
 */
const regeisterMod = (modName, cb) => {
    getModResources(modName).then(res => {
        // generate routes
        generateRoutes(modName, res.router).then(appendRoutes => {
            // register router
            appendRoutes.forEach(item => {
                if (!_.startsWith(item.path, 'http') && item.component) {
                    router.addRoute({
                        path: '/',
                        component: window.__MICRO_APP_ENVIRONMENT__ ? Root : Home,
                        children: [
                            {
                                path: item.path,
                                name: item.name,
                                component: item.component,
                                meta: {
                                    resourceName: item.meta.resourceName
                                }
                            }
                        ]
                    });
                }
            });
            cb();
        });
        // register store
        store.registerModule(modName, res.store);

        registeredRouterRecord.push(modName);
    });
};

router.beforeEach((to, from, next) => {
    const modName = splitModName(to.path);
    // 非基础模块 + 模块未注册 = 需要注册模块
    if (modName && !isModRegistered(modName)) {
        regeisterMod(modName, next.bind(null, to.fullPath));
        return;
    }
    if (to.meta.resourceName) {
        // 各页面添加各自大数据埋点全局变量
        // 这里需要延迟赋值，因为bigDataConfig是异步获取的，需要等待获取到后再赋值
        setTimeout(() => {
            window.bigDataConfig = bigDataConfig[to.name] || {};
        }, 80);
        // bigDataLog.sendMainMessage();
    }
    next();
    bigDataLog.sendDetailMessageOfRoute(to.fullPath)
});
export default router;
